import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _path;

const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

function EyeOpen(_ref) {
  let {
    size: sizeProp,
    title,
    titleId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.892 11.544C19.197 8.237 15.842 6 12 6c-3.842 0-7.198 2.239-8.892 5.544a1.01 1.01 0 000 .912C4.804 15.763 8.16 18 12.001 18c3.841 0 7.197-2.239 8.89-5.544a1.012 1.012 0 000-.912zM12 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zM12 9a2.98 2.98 0 00-.791.118 1.495 1.495 0 01-2.091 2.091A2.993 2.993 0 1012 9z"
  })));
}

EyeOpen.sizes = sizes;
EyeOpen.defaultProps = {
  size: sizes.md
};
EyeOpen.propTypes = {
  size: PropTypes.oneOf([EyeOpen.sizes.xs, EyeOpen.sizes.sm, EyeOpen.sizes.md, EyeOpen.sizes.lg, EyeOpen.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default EyeOpen;